import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import { dgda, logo, tra, logoZRA } from "./Imges";

class Export {

    getSimpleDeclaration(declaration) {
        declaration = declaration.trim();
        declaration = declaration.split(' ')[0];
        return declaration;
    }

    static formatedDate(date) {
        const d = new Date(date);
        return d.toLocaleDateString("fr");
    }

    static getConteneurs(conteneurs) {
        let conts = ""
        if (conteneurs) {

            conteneurs = conteneurs.trim();
            let i = 0;
            conteneurs.split(',').forEach(cont => {
                if (i == 0) {
                    conts += cont;
                    i++;
                }
                else conts += '\n' + cont
            });

        }
        return conts;

    }
    getImportateur(d) {
        const imp = d.importateur_id ? d.importateur_id : d.importateur_saisie;
        return imp;
    }

    getMarchandise(d) {
        const marc = d.nature_id ? d.nature_id : d.nature_saisie;
        return marc;
    }

    printHeader(doc) {

        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width;

        doc.addImage(tra, "PNG", 20, 10, 20, 20);
        doc.addImage(dgda, "PNG", pageWidth - 40, 10, 20, 20);
        doc.addImage(logo, "PNG", Math.ceil(pageWidth * 0.4), 12, 65, 10);
        doc.line(45, 25, pageSize.width - 45, 25);
        return doc
    }

    printHeaderLTRA(doc) {

        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width;

        doc.addImage(tra, "PNG", 40, 20, 40, 40);
        doc.addImage(dgda, "PNG", pageWidth - 80, 20, 40, 40);
        doc.addImage(logo, "PNG", Math.ceil(pageWidth * 0.4), 25, 130, 20);
        doc.line(90, 50, pageSize.width - 90, 50);
        return doc
    }

    printHeaderLZRA(doc) {

        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width;

        doc.addImage(logoZRA.image, "PNG", 40, 6, 70, 70);
        doc.addImage(dgda, "PNG", pageWidth - 80, 20, 40, 40);
        doc.addImage(logo, "PNG", Math.ceil(pageWidth * 0.4), 24, 130, 20);
        doc.line(110, 50, pageSize.width - 90, 50);
        return doc
    }

    printFooter(doc) {
        const nbr = doc.internal.getNumberOfPages();
        doc.setFontSize(9);
        let i = 0;
        for (i = 0; i < nbr; i++) {
            doc.setPage(i);
            let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; //Current Page
            doc.text('page: ' + pageCurrent + '/' + nbr, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 20, null, null, 'right');
        }
    }

    traListe(data) {
        //console.log(data);
        const doc = new jsPDF({
            orientation: 'l',
            unit: 'pt',
            format: 'letter'
        });

        this.printHeaderLTRA(doc);
        let positionY = 80;
        const columns = ["#", "Moyen Transport", "Importateur", "Marchandise", "Position", "Déclaration", "Poids", "Valeur Facture", "CIF"];
        var rows = [];
        let i = 1;
        let marc = "";
        let poids = 0;
        let valeur_facture = 0;
        let cif = 0
        data.forEach(d => {
            marc = d.nature_id ? d.nature_id : d.nature_saisie;
            poids += Number(d.poids);
            valeur_facture += Number(d.valeur_facture);
            cif += Number(d.cif);
            rows.push(
                [
                    i,
                    d.vehicule + "\n" + this.constructor.getConteneurs(d.conteneurs),
                    d.importateur,
                    d.nature, d.code_hs,
                    d.declaration + "\n" + d.debut_periode,
                    new Intl.NumberFormat('de-DE').format(
                        d.poids,
                    ),
                    new Intl.NumberFormat('de-DE').format(
                        d.valeur_facture,
                    ),
                    new Intl.NumberFormat('de-DE').format(
                        d.cif,
                    )
                ]
            );
            i++;
        });
        rows.push(
            [
                "", 'TOTAL', '', '', '', '',
                new Intl.NumberFormat('de-DE').format(poids),
                new Intl.NumberFormat('de-DE').format(valeur_facture),
                new Intl.NumberFormat('de-DE').format(cif)
            ]
        )
        doc.autoTable(columns, rows, {
            //addPageContent: pageContent,
            margin: { horizontal: 20, top: 30 },
            startY: positionY,
            styles: { overflow: 'linebreak', fontSize: 8 },
            columnStyles: {
                //id: { columnWidth: 25 },
                3: { columnWidth: 140 },
                //5: { halign: "right", fontStyle: "bold", fillColor: 40 }
                6: { halign: "right", fontStyle: "bold" },
                7: { halign: "right", fontStyle: "bold" },
                8: { halign: "right", fontStyle: "bold" }
                //role: { columnWidth: 15 },
                //location: { columnWidth: 30 }
            }
        });
        this.printFooter(doc);
        window.open(doc.output('bloburl'));
        //doc.output('dataurlnewwindow', { filename: "relaitz-tanzanie-" + Date.now() + ".pdf" });
    }

    zraListe(data) {
        const doc = new jsPDF({
            orientation: 'l',
            unit: 'pt',
            format: 'letter',
        });

        //doc.setFontSize(1);

        this.printHeaderLZRA(doc);
        let positionY = 80;
        const columns = ["#", "Moyen Transport", "Importateur", "Déclaration", "Date", "Mod.", "Art.", "Position", "Marchandise", "Poids", "CIF", "Dev."];
        var rows = [];
        let i = 1;
        let poids = 0;
        let fob = {};
        data.forEach(d => {
            const importateur = d.consignee_name.split('\n')[0];
            const vehicule = d.transport.plaques.replace('/', ' /');
            if (fob[d.currency])
                fob[d.currency] = fob[d.currency] + d.cif;
            else fob[d.currency] = d.cif;
            poids += d.poids;
            rows.push(
                [
                    i,
                    vehicule,
                    importateur, d.refDeclaration,
                    d.registration_date, d.modele, d.items, d.principal.tarif.position + " : " + d.principal.tarif.description, d.principal.goods_description,
                    new Intl.NumberFormat('de-DE').format(
                        d.poids,
                    ),
                    new Intl.NumberFormat('de-DE').format(
                        d.cif,
                    ),
                    d.currency
                ]
            );
            i++;
        });

        let index = 0
        Object.keys(fob).forEach(key => {
            if (index == 0) {
                rows.push(
                    [
                        "", 'TOTAL', '', '', '', '', '', '', '', new Intl.NumberFormat('de-DE').format(poids), new Intl.NumberFormat('de-DE').format(fob[key]), key
                    ]
                )
            }
            else {
                rows.push(
                    [
                        "", '', '', '', '', '', '', '', '', '', new Intl.NumberFormat('de-DE').format(fob[key]), key
                    ]
                )
            }
            index++;
        }
        );

        doc.autoTable(columns, rows, {
            //addPageContent: pageContent,
            margin: { horizontal: 20, top: 30 },
            startY: positionY,
            styles: { overflow: 'linebreak', fontSize: 8 },
            columnStyles: {
                //id: { columnWidth: 25 },
                8: { columnWidth: 100 },
                //5: { halign: "right", fontStyle: "bold", fillColor: 40 }
                9: { halign: "right", fontStyle: "bold" },
                10: { halign: "right", fontStyle: "bold" },
                11: { halign: "right", fontStyle: "bold" },
                12: { halign: "left", fontStyle: "bold" }
            }
        });
        this.printFooter(doc);
        //window.open(doc.OU ("relaitz-impression-" + Date.now() + ".pdf"));
        /*const string = doc.output("bloburl");
        const newWindow = window.open();
        newWindow.document.write(`<iframe width="100%" height="100%" src="${string}"></iframe>`);
        newWindow.document.title = "relaitz-impression-" + Date.now() + ".pdf";*/
        //doc.output('dataurlnewwindow', { filename: "relaitz-impression-" + Date.now() + ".pdf" });
        //doc.save("relaitz-impression-" + Date.now() + ".pdf");

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Ouvrir le PDF dans une nouvelle fenêtre
        const pdfWindow = window.open(pdfUrl, '_blank');
        pdfWindow.document.title = "relaitz-impression-" + Date.now() + ".pdf";

        // Définir le nom de fichier par défaut à l'aide de FileSaver.js
        //const link = document.createElement('a');
        //link.href = pdfUrl;
        //link.download = 'nom_du_fichier_par_defaut.pdf';
        //link.click();

        // Optionnel: Révoquer l'URL blob après utilisation
        URL.revokeObjectURL(pdfUrl);
    }

    printMarchaniseDetails(element, complements = []) {
        console.log(complements);
        const imp = element.importateur_id ? element.importateur_id : element.importateur_saisie;
        const mar = element.nature_id ? element.nature_id : element.nature_saisie;


        const doc = new jsPDF();
        var totalPagesExp = '{total_pages_count_string}';
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width;
        const pageHeight = pageSize.height;
        const margin = 10;

        doc.setFontSize(11);
        //doc.setTextColor(7, 200, 7);

        doc.addImage(tra, "PNG", 20, 10, 20, 20);
        doc.addImage(dgda, "PNG", pageWidth - 40, 10, 20, 20);
        doc.addImage(logo, "PNG", 75, 12, 65, 10);
        let positionY = 20;

        //doc.text("RelaiTZ.Online", 105, positionY, null, null, "center");
        doc.line(45, positionY + 5, pageSize.width - 45, positionY + 5);
        positionY += 20;
        doc.setFont('helvetica');
        doc.setFont('helvetica', 'bold');
        doc.text(["Véhicule : ", "Importateur : ", "Expéditeur : ", "Marchandise : ", "Rubrique : ", "Conteneur : "], 20, positionY, { lineHeightFactor: 2 });

        doc.setFont('helvetica', 'light');
        doc.text([element.moyen_transport, imp, element.expediteur, mar, element.hs, this.constructor.getConteneurs(element.conteneurs)], 50, positionY, { lineHeightFactor: 2 });
        positionY += 42;

        doc.setFont('helvetica', 'bold');
        doc.line(margin, positionY, pageWidth - margin, positionY);
        positionY += 10;
        doc.text(["POIDS", "CIF TANZ (USD) : ", "VALEUR FACTURE : ", "FRET : "], 20, positionY, { lineHeightFactor: 1.5 });
        doc.text([
            new Intl.NumberFormat('de-DE').format(
                element.quantite,
            ),
            new Intl.NumberFormat('de-DE').format(
                element.valeur,
            ),
            new Intl.NumberFormat('de-DE').format(
                element.facture,
            ),
            new Intl.NumberFormat('de-DE').format(
                element.fret,
            )], 105, positionY, { lineHeightFactor: 1.5, align: 'right' });

        //positionY = Math.ceil(pageHeight * 0.45);
        positionY += 30;
        var columns = [];
        var rows = [];

        columns = ["N°Déclaration", "Modèle", "Date T1", "N°Facture", "Date Facture"];
        rows = [
            [element.declaration, element.modele, element.date_t1, element.numero_facture, element.date_facture]
        ];
        doc.autoTable(columns, rows, { startY: positionY });
        positionY += 15;

        columns = ["Pays O/E", "B/L", "Châssis", "Destination"];
        rows = [
            [element.pays, element.bl, element.chassis, element.destination]
        ];
        doc.autoTable(columns, rows, { startY: positionY });
        positionY += 25;

        doc.setFont(undefined, 'bold');
        doc.text("Pour la même déclaration : ", 20, positionY);
        positionY += 5;

        columns = ["#", "Véhicule", "Nature", "Poids", "Quantité", "CIF"];
        rows = [];
        let i = 1;
        let marc = "";
        complements.forEach(complement => {
            marc = complement.nature_id ? complement.nature_id : complement.nature_saisie;
            rows.push(
                [
                    i, complement.moyen_transport, marc, complement.quantite, complement.colis, complement.valeur
                ]
            );
            i++;
        });
        // Only pt supported (not mm or in)
        doc.autoTable(columns, rows, { startY: positionY });

        doc.setFont(undefined, 'bold');
        //doc.text(["Déclaration : ", " : ", "Marchandise : ", "Rubrique : "], 20, positionY, { lineHeightFactor: 2 });
        //doc.text(["Poids : ", "CIF Tanz/USD : ", "Marchandise : ", "Rubrique : "], Math.ceil(pageSize.width / 2), positionY, { lineHeightFactor: 2 });

        //doc.setTextColor(25, 255, 25);
        doc.setFont(undefined, 'regular');
        // doc.text([element.moyen_transport, "", "", element.hs], 50, positionY, { lineHeightFactor: 2, maxWidth: 40 });
        //doc.text(["Poids", "CIF Tanz/USD", "Marchandise", "Rubrique"], Math.ceil(pageSize.width / 2) + 50, positionY, { lineHeightFactor: 2 });
        //doc.save("a4.pdf");
        //window.open(doc.output('bloburl'));
        doc.save("relaitz-impression-" + Date.now() + ".pdf");
    }

    printTZDeclaration(elements) {
        console.log(elements);
        const general = elements[0];
        var columns = [];
        var rows = [];



        const doc = new jsPDF();
        var totalPagesExp = '{total_pages_count_string}';
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width;
        const pageHeight = pageSize.height;
        const margin = 10;

        doc.setFontSize(11);
        //doc.setTextColor(7, 200, 7);

        doc.addImage(tra, "PNG", 20, 10, 20, 20);
        doc.addImage(dgda, "PNG", pageWidth - 40, 10, 20, 20);
        doc.addImage(logo, "PNG", 75, 12, 65, 10);
        let positionY = 20;

        //doc.text("RelaiTZ.Online", 105, positionY, null, null, "center");
        doc.line(45, positionY + 5, pageSize.width - 45, positionY + 5);
        positionY += 20;
        doc.setFont('helvetica');
        doc.setFont('helvetica', 'bold');
        doc.text(["Modèle", "Importateur : ", "Expéditeur : ", "Marchandise : ", "Rubrique : "], 20, positionY, { lineHeightFactor: 2 });

        doc.setFont('helvetica', 'light');
        doc.text([general.modele, general.importateur, general.expediteur, general.nature, general.code_hs], 50, positionY, { lineHeightFactor: 2 });
        positionY += 42;

        /*doc.setFont('helvetica', 'bold');
        doc.line(margin, positionY, pageWidth - margin, positionY);
        positionY += 10;
        doc.text(["POIDS", "CIF TANZ (USD) : ", "VALEUR FACTURE : ", "FRET : "], 20, positionY, { lineHeightFactor: 1.5 });
        doc.text([
            new Intl.NumberFormat('de-DE').format(
                element.quantite,
            ),
            new Intl.NumberFormat('de-DE').format(
                element.valeur,
            ),
            new Intl.NumberFormat('de-DE').format(
                element.facture,
            ),
            new Intl.NumberFormat('de-DE').format(
                element.fret,
            )], 105, positionY, { lineHeightFactor: 1.5, align: 'right' });

        //positionY = Math.ceil(pageHeight * 0.45);
        positionY += 30;
        

        columns = ["N°Déclaration", "Modèle", "Date T1", "N°Facture", "Date Facture"];
        rows = [
            [element.declaration, element.modele, element.date_t1, element.numero_facture, element.date_facture]
        ];
        doc.autoTable(columns, rows, { startY: positionY });
        positionY += 15;

        columns = ["Pays O/E", "B/L", "Châssis", "Destination"];
        rows = [
            [element.pays, element.bl, element.chassis, element.destination]
        ];
        doc.autoTable(columns, rows, { startY: positionY });*/
        positionY += 25;

        doc.setFont(undefined, 'bold');
        doc.text("Pour la même déclaration : ", 20, positionY);
        positionY += 5;

        columns = ["#", "Véhicule", "Conteneur / Chassis", "Quantité", "Poids", "Valeur Facture", "CIF"];
        rows = [];
        let i = 1;
        let marc = "";
        elements.forEach(complement => {
            marc = complement.nature_id ? complement.nature_id : complement.nature_saisie;
            rows.push(
                [
                    i, complement.vehicule, complement.conteneurs + " / " + complement.chassis,
                    complement.quantite, complement.poids, complement.valeur_facture,
                    complement.cif
                ]
            );
            i++;
        });
        // Only pt supported (not mm or in)
        doc.autoTable(columns, rows, { startY: positionY });

        doc.setFont(undefined, 'bold');
        //doc.text(["Déclaration : ", " : ", "Marchandise : ", "Rubrique : "], 20, positionY, { lineHeightFactor: 2 });
        //doc.text(["Poids : ", "CIF Tanz/USD : ", "Marchandise : ", "Rubrique : "], Math.ceil(pageSize.width / 2), positionY, { lineHeightFactor: 2 });

        //doc.setTextColor(25, 255, 25);
        doc.setFont(undefined, 'regular');
        // doc.text([element.moyen_transport, "", "", element.hs], 50, positionY, { lineHeightFactor: 2, maxWidth: 40 });
        //doc.text(["Poids", "CIF Tanz/USD", "Marchandise", "Rubrique"], Math.ceil(pageSize.width / 2) + 50, positionY, { lineHeightFactor: 2 });
        //doc.save("a4.pdf");
        window.open(doc.output('bloburl'));

        //doc.save("relaitz-impression-" + Date.now() + ".pdf");
    }
}

export default Export